import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationSandbox } from '@app/authentication/sandboxes/authentication.sandbox';
import { Services } from '@app/services/enums/services.enum';
import { Role } from '@core/enums';
import { StringUtils } from '@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { RxjsComponent } from '@core/rxjs';

@Component({
    selector: 'app-service-ready-to-submit',
    standalone: true,
    imports: [NgOptimizedImage, TranslateModule, AsyncPipe],
    template: ` <div class="u-flex-column">
        <img
            class="mx-auto"
            ngSrc="https://assets.smooved.be/illustrations/v2/spot/complete.webp"
            width="100"
            height="100"
            [priority]="true"
        />
        <p class="text-title-md text-center mb-1">
            {{ titleLabel$ | async | translate }}
        </p>
        <p class="text-body-md text-secondary text-center">
            {{ textLabel$ | async | translate }}
        </p>
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceReadyToSubmitComponent extends RxjsComponent implements OnInit {
    @Input() public service: Services = Services.EnergyStop;

    @Input() set diy(value: boolean) {
        this.diy$.next(value);
    }

    private readonly authenticationSandbox = inject(AuthenticationSandbox);
    private readonly diy$ = new BehaviorSubject<boolean>(false);

    public titleLabel$: Observable<string>;
    public textLabel$: Observable<string>;

    ngOnInit(): void {
        this.initializeObservables();
    }

    private initializeObservables(): void {
        this.titleLabel$ = combineLatest([this.authenticationSandbox.role$, this.diy$]).pipe(
            takeUntil(this.destroy$),
            map(([role, diy]) => {
                if (!role || !this.service) return null;
                return `V2.SERVICES.${StringUtils.toUpperSnakeCase(this.service)}.READY_TO_SUBMIT.${diy ? 'DIY_' : ''}TITLE`;
            }),
        );

        this.textLabel$ = combineLatest([this.authenticationSandbox.role$, this.diy$]).pipe(
            takeUntil(this.destroy$),
            map(([role, diy]) => {
                if (!role || !this.service) return null;
                return `V2.SERVICES.${StringUtils.toUpperSnakeCase(this.service)}.READY_TO_SUBMIT.${diy ? 'DIY_' : ''}TEXT_${role === Role.Mover ? 'MOVER' : 'DEFAULT'}`;
            }),
        );
    }
}
